import {PriceStrategyService} from "../../../components/inputs/price/service/PriceStrategyService";
import {MarketMoverRecord, MarketMoversRecord, MarketMoversStateRecord} from "../types/MarketMoversState";
import {MarketMoverModel, MarketMoversModel, MarketMoversStateModel} from "../models/MarketMoversStateModel";

export class MarketMoverModelFactory {

    public static readonly id = "marketMoverModelFactory";

    /** @ngInject */
    public constructor(private readonly priceStrategyService: PriceStrategyService) {
    }

    public build(record: MarketMoversStateRecord): MarketMoversStateModel {
        const top200 = this.buildMovers(record.top200);
        const all = this.buildMovers(record.all);
        return {top200, all};
    }

    private buildMovers(record: MarketMoversRecord): MarketMoversModel {
        const gainers = record.gainers.map((g) => this.buildMoverModel(g));
        const losers = record.losers.map((l) => this.buildMoverModel(l));
        return {gainers, losers};
    }

    private buildMoverModel(record: MarketMoverRecord): MarketMoverModel {
        const strategy = this.priceStrategyService.forCode(record.code);
        return MarketMoverModel.of(record, strategy);
    }
}
